import gql from 'graphql-tag';

export const updateMeshNetworkMutation = gql`
  mutation ($input: MeshNetworkUpdateInput) {
    updateMeshNetwork(input: $input)
    {
      meshNetworkId
      name
      networkKey
      status
      date
      provisioner {
        deviceId
        serial
        mac
      }
    }
  }
`
